export const isFocusLost = (): boolean => !document.activeElement || document.activeElement === document.body;
